export default (apiMethods, endpoints) => ({
    getStories: () => {
        return apiMethods.get(endpoints.GET_STORIES_ENDPOINT);
    },
    getStoryRequests: () => {
        return apiMethods.get(endpoints.GET_STORIES_REQUESTS_ENDPOINT);
    },
    getStory: (storyID) => {
        return apiMethods.get(endpoints.GET_STORY_ENDPOINT(storyID));
    },
    addStory: (data) => {
        let formdata = new FormData();
        formdata.append('name', data.name);
        if (data.category) {
            formdata.append('category', data.category)
        }
        formdata.append('published', data.published)
        formdata.append('storage', data.storage)
        formdata.append('traffic', data.traffic)
        if (data.endDate) {
            let end = new Date(data.endDate);
            formdata.append('endDate', end.toISOString())
        }
        !data.description || formdata.append('description', data.description)

        if (data.products) {
            data.products.forEach(p => {
                formdata.append('products[]', p)
            })
        }

        if (data.storyPath) {
            formdata.append('storyPath', data.storyPath);
        }

        if (data.privateStory) {
            formdata.append('privateStory', data.privateStory);
        }
        if (data.storyAccessLink) {
            formdata.append('storyAccessLink', data.storyAccessLink);
        }
        if (data.dataCollection) {
            formdata.append('dataCollection', data.dataCollection);
        }
        return apiMethods.post(endpoints.CREATE_STORY_ENDPOINT, formdata, {
            'Content-Type': 'multipart/form-data'
        });


    },
    updateStory: (data, storyId) => {
        let formdata = new FormData();

        if (data.name) {
            formdata.append('name', data.name);
        }

        if (data.category) {
            formdata.append('category', data.category)
        }
        if (typeof data.published !== 'undefined') {
            formdata.append('published', data.published)
        }
        if (data.traffic) {
            formdata.append('traffic', data.traffic)
        }
        if (data.storage) {
            formdata.append('storage', data.storage)
        }
        if (data.endDate) {
            let end = new Date(data.endDate);
            formdata.append('endDate', end.toISOString())
        }
        if (data.price) {
            formdata.append('price', data.price)
        }
        if (data.priceSet) {
            formdata.append('priceSet', data.priceSet)
        }

        if (data.description) {
            formdata.append('description', data.description)
        }
        if (data.adminApproved) {
            formdata.append('adminApproved', data.adminApproved)
        }

        if (data.categories) {
            formdata.append('categories', JSON.stringify(data.categories))
        }

        if (data.sectionImages) {
          Object.keys(data.sectionImages).forEach(sectionId => {
            formdata.append(`sectionImages_${sectionId}`, data.sectionImages[sectionId]);
          });
        }

        if (data.changeStoryPath) {
            formdata.append('storyPath', data.changeStoryPath);
        }
        
        if (typeof data.authorName !== 'undefined') {
            formdata.append('authorName', data.authorName);
        }

        if (typeof data.privateStory !== 'undefined') {
            formdata.append('privateStory', data.privateStory);
        }

        if (typeof data.storyAccessLink !== 'undefined') {
            formdata.append('storyAccessLink', data.storyAccessLink);
        }

        if (typeof data.dataCollection !== 'undefined') {
            formdata.append('dataCollection', data.dataCollection);
        }

        return apiMethods.put(endpoints.UPDATE_STORY_ENDPOINT(storyId), formdata, {
            'Content-Type': 'multipart/form-data'
        });
    },
    deleteStory: (storyID) => {
        return apiMethods.delete(endpoints.DELETE_STORY_ENDPOINT(storyID));
    },

})



// WEBPACK FOOTER //
// ./src/lib/api-stories.js